import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function PinFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2C15.642 2 19 5.404 19 9.602c0 1.376-.472 2.85-1.143 4.26-.675 1.415-1.569 2.805-2.454 4.023a42.046 42.046 0 01-2.436 3.03c-1.302 1.478-1.687 1.415-2.934 0a42.056 42.056 0 01-2.436-3.03c-.885-1.218-1.78-2.608-2.454-4.024C4.473 12.452 4 10.978 4 9.602 4 5.404 7.358 2 11.5 2zm0 3.5a4 4 0 100 8 4 4 0 000-8z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(PinFill);
export default ForwardRef;